import { createAction } from "redux-act";

export const requestATSList = createAction("REQUEST_ATS_LIST");
export const receiveATSList = createAction("RECEIVE_ATS_LIST");
export const failATSList = createAction("FAILED_ATS_LIST");
